// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__SHuU3","Arcade_wrapper":"style_Arcade_wrapper__NTGFv"};